import { Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs, useMediaQuery, useTheme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { ForgotPassword, SignIn, SignUp } from 'views/auth';
import { useStyle } from './authDialog.style';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
};

export const AuthDialog: React.FC = () => {
    const classes = useStyle();

    const { t } = useTranslation();
    const { isModalOpen, closeModal, selectedTab, selectTab } = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    useEffect(() => {
        selectTab(0);
    }, [isModalOpen, selectTab]);

    const onTabChange = (_, tabIndex) => {
        selectTab(tabIndex);
    };

    return (
        <Dialog
            disableBackdropClick
            fullScreen={isMobile}
            open={isModalOpen}
            classes={{ paper: classes.dialog }}
            onClose={closeModal}
        >
            <DialogTitle disableTypography className={classes.header}>
                <Tabs value={selectedTab} onChange={onTabChange}>
                    <Tab
                        label={t('auth:logIn')}
                        style={{ border: 'none' }}
                        disableRipple
                        classes={{ selected: classes.navButtonActive }}
                        className={classes.navButton}
                    />
                    <Tab
                        label={t('auth:register')}
                        disableRipple
                        classes={{ selected: classes.navButtonActive }}
                        className={classes.navButton}
                    />
                </Tabs>

                <IconButton size="small" className={classes.close} onClick={closeModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <TabPanel value={selectedTab} index={0}>
                    <SignIn />
                </TabPanel>

                <TabPanel value={selectedTab} index={1}>
                    <SignUp />
                </TabPanel>

                <TabPanel value={selectedTab} index={2}>
                    <ForgotPassword />
                </TabPanel>
            </DialogContent>
        </Dialog>
    );
};
